import styled from 'styled-components';
import { breakpoints } from '@bnnvara/breakpoints';

export const PlayerWrapper = styled.div`
  padding-top: 0;
  margin-bottom: 25px;

  ${breakpoints.xl} {
    margin-bottom: -15%;
  }
`;

export const ImageWrapper = styled.div`
  height: auto;
  max-width: 1125px;
  margin: 0 auto;
  margin-bottom: 32px;
  display: flex;
  justify-content: center;

  img {
    width: 100%;
  }
`;
